import { z } from 'zod';
import { HexColor, Id, TagSource, UnitInterval, atLeastOneField, cursorPage } from './common.js';

export const Tag = z.object({
  id: Id,
  workspace_id: Id,
  name: z.string().max(100),
  color: HexColor.nullable().optional(),
  source: TagSource,
  asset_count: z.int().optional(),
  /** Release 2 G1: tag group. */
  group_id: Id.nullable().optional(),
});
export type Tag = z.infer<typeof Tag>;

export const TagPage = cursorPage(Tag);
export type TagPage = z.infer<typeof TagPage>;

export const TagCreate = z.object({
  name: z.string().min(1).max(100),
  color: HexColor.optional(),
  group_id: Id.nullable().optional(),
});
export type TagCreate = z.infer<typeof TagCreate>;

export const TagUpdate = atLeastOneField(
  z.object({
    name: z.string().min(1).max(100).optional(),
    color: HexColor.nullable().optional(),
    /** null ungroups (Release 2 G1). */
    group_id: Id.nullable().optional(),
  }),
);
export type TagUpdate = z.infer<typeof TagUpdate>;

export const AssetTag = z.object({
  tag: Tag,
  source: TagSource,
  confidence: UnitInterval.nullable().optional(),
  added_by: Id.nullable().optional(),
});
export type AssetTag = z.infer<typeof AssetTag>;

/** Provide `tag_ids`, `names`, or both. */
export const AssetTagsAdd = z
  .object({
    tag_ids: z.array(Id).optional(),
    names: z.array(z.string().min(1).max(100)).optional(),
  })
  .refine((o) => o.tag_ids !== undefined || o.names !== undefined, {
    message: 'tag_ids or names is required',
  });
export type AssetTagsAdd = z.infer<typeof AssetTagsAdd>;
